import { Dashboard } from '../../types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const dashboardsService = {
  listByLicense: async (siteId: string, licenseName: string): Promise<Dashboard[]> => {
    const response = await apiClient.get<Dashboard[]>(ENDPOINTS.dashboards.list(siteId), {
      params: { LicenseName: licenseName },
    })
    return response.data
  },

  get: async (siteId: string, dashboardId: string): Promise<Dashboard> => {
    const response = await apiClient.get<Dashboard>(ENDPOINTS.dashboards.get(siteId, dashboardId))
    return response.data
  },
}
